import { createContext } from 'react';

const OnCloseContext = /*#__PURE__*/createContext(undefined);

export { OnCloseContext as O };
//# sourceMappingURL=Context-dY1G4PQg.js.map
